import React from 'react';
import { Box, Typography } from '@mui/material';

const SettingsPage = ({ title, description, actions, children, sx }) => {
  return (
    <Box sx={{ p: 4, ...sx }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          gap: 2,
          mb: 1,
        }}
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="h4" sx={{ mb: 1, fontWeight: 600 }}>
            {title}
          </Typography>
          {description ? (
            <Typography variant="body2" color="text.secondary" sx={{ mb: 0 }}>
              {description}
            </Typography>
          ) : null}
        </Box>

        {actions ? <Box sx={{ flexShrink: 0 }}>{actions}</Box> : null}
      </Box>

      <Box sx={{ mt: 4 }}>{children}</Box>
    </Box>
  );
};

export default SettingsPage;
